'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import PropTypes from 'prop-types';
import { getEventValue } from 'reporting-action-components/utils/jsEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FormattingOptions = ({
  setReportsPerPage,
  reportsPerPage
}) => {
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "export.email.options.label"
    }),
    children: /*#__PURE__*/_jsxs(UIToggleGroup, {
      name: "formatType",
      inline: true,
      children: [/*#__PURE__*/_jsx(UIRadioInput, {
        name: "formatType",
        value: 1,
        onChange: e => setReportsPerPage(parseInt(getEventValue(e), 10)),
        checked: reportsPerPage === 1,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "export.email.options.one"
        })
      }), /*#__PURE__*/_jsx(UIRadioInput, {
        name: "formatType",
        value: 2,
        onChange: e => setReportsPerPage(parseInt(getEventValue(e), 10)),
        checked: reportsPerPage > 1,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "export.email.options.multi"
        })
      })]
    })
  });
};
FormattingOptions.propTypes = {
  setReportsPerPage: PropTypes.func.isRequired,
  reportsPerPage: PropTypes.number.isRequired
};
export default FormattingOptions;